import React, { createContext, useContext, useState } from "react";

const HistoryContext = createContext();

export const useHistoryData = () => useContext(HistoryContext);

export const HistoryProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [fetched, setFetched] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true); // Added to persist loader state across remounts

  const resetHistory = () => {
    setItems([]);
    setFetched(false);
    setInitialLoading(true);
  };

  return (
    <HistoryContext.Provider
      value={{
        items,
        setItems,
        fetched,
        setFetched,
        initialLoading,       // Expose loader flag
        setInitialLoading,    // Expose loader setter
        resetHistory,
      }}
    >
      {children}
    </HistoryContext.Provider>
  );
};
